import { TeamviewerButton } from "@/lib/components";

export const Help = () => {
    return <TeamviewerButton textKey="button.teamviewer" />;
}